import React, { memo } from 'react';

import { areEqual } from 'Utils/equalityChecks';
import { Spinner } from 'Components/Spinner';
import { useGHLProvider, GHLContext } from '.';

interface Props {
  children: React.ReactNode;
}

// GHL Provider - wraps GHL-embedded routes with GHL context
const GHLProvider = ({ children }: Props) => {
  const ghlUser = useGHLProvider();

  if (ghlUser.isLoading) {
    return <Spinner loading />;
  }

  return (
    <GHLContext.Provider value={ghlUser}>
      {children}
    </GHLContext.Provider>
  );
};

const GHLProviderMemo = memo(GHLProvider, areEqual);

export { GHLProviderMemo as GHLProvider };
